import { jsx as u } from "react/jsx-runtime";
import { createContext as s, useContext as n } from "react";
const o = s(null);
function r({ assetsBaseUrl: t = "/ui", children: e }) {
  return /* @__PURE__ */ u(
    o.Provider,
    {
      value: {
        assetsBaseUrl: t
      },
      children: e
    }
  );
}
((t) => {
  function e(i) {
    if (!n(o) && !i)
      throw new Error("useUi must be used within a Ui context");
    return n(o);
  }
  t.useUi = e;
})(r || (r = {}));
export {
  r as Ui
};
//# sourceMappingURL=Ui.js.map
